(function () {

  /* =========================
     CONFIG
  ========================= */

  var targetPaths = [
    '/products/colored-wireless2',
    '/products/metalbundles',
    '/products/2-2l-fountain',
    '/products/wireless-spout',
    '/products/kittyspout-wireless-fountain',
    '/products/colored-oakv2'
  ];

  var doggyPath = '/products/doggyspout-v1';

  function isTargetPage() {
    return targetPaths.indexOf(location.pathname) !== -1;
  }

  function isDoggyPage() {
    return location.pathname === doggyPath;
  }

  // Hard exit — nothing runs outside target or doggy pages
  if (!isTargetPage() && !isDoggyPage()) return;

  /* =========================
     HEADER
  ========================= */

  function cleanHeader() {
    if (!isTargetPage()) return;

    var isMobile = window.innerWidth < 769;

    if (isMobile) {
      // Mobile: remove hamburger and cart icon
      document.querySelectorAll('.js-drawer-open-nav').forEach(el => el.remove());
      document.querySelectorAll('.js-drawer-open-cart').forEach(el => el.remove());

      // Mobile: shift logo image to center via left offset
      document.querySelectorAll('.site-header .site-header__logo img').forEach(function (img) {
        img.style.setProperty('left', '120%', 'important');
      });

      // Mobile: hide icons wrapper so it doesn't interfere with layout
      var iconsItem = document.querySelector('.header-item--icons');
      if (iconsItem) iconsItem.style.display = 'none';

    } else {
      // Desktop: remove nav and icons bar, center logo
      document.querySelectorAll('.header-item--navigation').forEach(el => el.remove());
      document.querySelectorAll('.header-item--icons').forEach(el => el.remove());
      document.querySelectorAll('[data-rebuy-id]').forEach(el => el.style.display = 'none');

      var desktopLayout = document.querySelector('.header-layout');
      if (desktopLayout) {
        desktopLayout.style.display = 'flex';
        desktopLayout.style.justifyContent = 'center';
        desktopLayout.style.alignItems = 'center';
      }

      var logo = document.querySelector('.header-item--logo');
      if (logo) {
        logo.style.margin = '0 auto';
        logo.style.flex = '0 0 auto';
      }
    }
  }

  /* =========================
     FOOTER
  ========================= */

  function cleanFooter() {
    if (!isTargetPage()) return;

    var footer = document.querySelector('.site-footer');
    if (!footer) return;

    var isMobile = window.innerWidth < 769;

    if (isMobile) {
      // Mobile: remove newsletter column
      footer.querySelectorAll('.footer__item--footer2').forEach(el => el.remove());

      // Mobile: remove the KittySpout menu column entirely
      footer.querySelectorAll('.footer__item--fa108a61-0d4b-421b-b92a-d497a7a46431').forEach(el => el.remove());

      // Mobile: keep only privacy policy, terms of service, shipping & delivery — matched by href
      var keepHrefs = [
        '/policies/privacy-policy',
        '/policies/terms-of-service',
        '/pages/shipping-delivery'
      ];

      footer.querySelectorAll('.footer__item--footer-1 li').forEach(function (li) {
        var link = li.querySelector('a');
        if (!link) { li.remove(); return; }
        var href = link.getAttribute('href');
        var keep = keepHrefs.some(function (h) { return href && href.indexOf(h) !== -1; });
        if (!keep) li.remove();
      });

    } else {
      // Desktop: remove newsletter column
      footer.querySelectorAll('.footer__item--footer2').forEach(el => el.remove());

      // Desktop: remove the KittySpout menu column entirely
      footer.querySelectorAll('.footer__item--fa108a61-0d4b-421b-b92a-d497a7a46431').forEach(el => el.remove());

      // Desktop: remove column title and collapsible toggle from the legal column
      footer.querySelectorAll('.footer__item--footer-1 .footer__title').forEach(el => el.remove());
      footer.querySelectorAll('.footer__item--footer-1 .collapsible-trigger').forEach(el => el.remove());

      // Desktop: keep only privacy policy, terms of service, shipping & delivery — matched by href
      var desktopKeepHrefs = [
        '/policies/privacy-policy',
        '/policies/terms-of-service',
        '/pages/shipping-delivery'
      ];

      footer.querySelectorAll('.footer__item--footer-1 li').forEach(function (li) {
        var link = li.querySelector('a');
        if (!link) { li.remove(); return; }
        var href = link.getAttribute('href');
        var keep = desktopKeepHrefs.some(function (h) { return href && href.indexOf(h) !== -1; });
        if (!keep) li.remove();
      });

      // Desktop: native copyright is already present — do not duplicate it
    }
  }

  /* =========================
     CTA TEXT
  ========================= */

  function forceCTAText() {
    if (!isTargetPage()) return;

    document.querySelectorAll(
      'button[data-add-to-cart], .cw-sticky-btn, .cw-trigger-js'
    ).forEach(function (btn) {
      if (btn.innerText.trim() !== 'TRY IT RISK-FREE TODAY') {
        btn.innerText = 'TRY IT RISK-FREE TODAY';
      }
    });
  }

  /* =========================
     INIT
  ========================= */

  cleanHeader();
  cleanFooter();
  forceCTAText();

  new MutationObserver(function () {
    cleanHeader();
    cleanFooter();
    forceCTAText();
  }).observe(document.body, {
    childList: true,
    subtree: true
  });

  /* =========================
     DOGGY SPOUT
  ========================= */

  (function () {
    if (!isDoggyPage()) return;

    var atcFired = false;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-add-to-cart], .cw-sticky-btn, .cw-trigger-js');
      if (!btn) return;

      if (atcFired) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      atcFired = true;
      e.preventDefault();
      e.stopImmediatePropagation();

      btn.innerText = 'TRY IT RISK-FREE TODAY';
      btn.disabled = true;

      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(r => r.json())
        .then(() => {
          if (window.Rebuy && window.Rebuy.SmartCart) {
            window.Rebuy.SmartCart.show();
          }
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: {} })
          });
        })
        .then(() => {
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 3000);
        })
        .catch(() => {
          window.location.href = '/checkout';
        });

    }, true);
  })();

  /* =========================
     PRODUCT ATC FLOW
  ========================= */

  (function () {

    var productConfig = {
      '/products/colored-wireless2':            ['colored-wireless2', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit'],
      '/products/metalbundles':                 ['metalbundles', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit'],
      '/products/2-2l-fountain':                ['2-2l-fountain', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit'],
      '/products/wireless-spout':               ['wireless-spout', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit'],
      '/products/kittyspout-wireless-fountain': ['kittyspout-wireless-fountain', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit'],
      '/products/colored-oakv2':                ['colored-oakv2', 'cleaning-brush', 'gift', 'free-cat-toy', 'anti-splash-mat-for-the-kittyspout-cat-kit']
    };

    var required = productConfig[location.pathname];
    if (!required) return;

    var atcFired = false;

    function getCart() {
      return fetch('/cart.js').then(r => r.json());
    }

    function hasAll(cart) {
      var handles = cart.items.map(i => i.handle);
      return required.every(h => handles.includes(h));
    }

    function waitCart() {
      var start = Date.now();
      return new Promise(function (res, rej) {
        function loop() {
          getCart().then(function (cart) {
            if (hasAll(cart)) return res();
            if (Date.now() - start > 20000) return rej();
            setTimeout(loop, 300);
          });
        }
        loop();
      });
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-add-to-cart], .cw-sticky-btn, .cw-trigger-js');
      if (!btn) return;

      if (atcFired) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      atcFired = true;
      e.preventDefault();
      e.stopImmediatePropagation();

      btn.innerText = 'TRY IT RISK-FREE TODAY';

      var form = document.querySelector('form[action="/cart/add"]');
      if (!form) return;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(() => fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({})
        }))
        .then(waitCart)
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(() => {
          atcFired = false;
        });

    }, true);

  })();

})();